export default __webpack_public_path__ + "static/media/vote@2x.903ccffa.png";